const hasConsole = !!console;

const debug = function debug(...args) {
    console.debug(args);
};

const info = function info(...args) {
    console.info(args);
};

const error = function error(...args) {
    console.error(args);
};

const warn = function warn(...args) {
    console.warn(args);
};

const returnObject = {
    debug: hasConsole ? debug : function dummy() {},
    info: hasConsole ? info : function dummy() {},
    error: hasConsole ? error : function dummy() {},
    warn: hasConsole ? warn : function dummy() {},
};

export { returnObject as default };



// WEBPACK FOOTER //
// ../loader-base/src/helpers/log-helper.js